// extracted by mini-css-extract-plugin
module.exports = {"CustomInputNumber":"CustomInputNumber__CustomInputNumber___1Sg64","InputValue":"CustomInputNumber__InputValue____BHfY","Icon":"CustomInputNumber__Icon___3qhEd"};